/**
 * Utility functions for contract data processing
 * Used across MarketPage, AdminDashboard, ClientDashboard
 */

export const deduplicateContracts = (contracts) => {
  const getBaseKey = (name) => {
    return name
      .replace(/\s*base\s*/gi, ' ')
      .replace(/\s*[YQM]\+\d+/gi, '')
      .replace(/\s+/g, ' ')
      .trim();
  };
  
  const groups = {};
  contracts.forEach(c => {
    const key = getBaseKey(c.contract_name);
    if (!groups[key]) {
      groups[key] = c;
    } else {
      const existingDate = groups[key].date || '';
      const newDate = c.date || '';
      if (newDate > existingDate) {
        groups[key] = c;
      }
    }
  });
  return Object.values(groups);
};

// Sort contracts: Spot -> Monthly -> Quarterly -> Calendar (matching PDF newsletter order)
export const sortContracts = (contracts) => {
  const getOrder = (name) => {
    const n = name.toUpperCase();
    if (n.includes('SPOT')) return { group: 0, year: 0, sub: 0 };
    if (n.match(/M\+\d/) || n.match(/(JAN|FEV|MAR|AVR|MAI|JUN|JUL|AOU|SEP|OCT|NOV|DEC|APR|MAY|FEB|AUG)/)) {
      const mMatch = n.match(/M\+(\d+)/);
      return { group: 1, year: 0, sub: mMatch ? parseInt(mMatch[1]) : 0 };
    }
    const qMatch = n.match(/Q(\d)\s*(\d+)/);
    if (qMatch) {
      const quarter = parseInt(qMatch[1]);
      const year = parseInt(qMatch[2]);
      return { group: 2, year: year, sub: quarter };
    }
    const calMatch = n.match(/CAL\s*(\d+)/);
    if (calMatch) return { group: 3, year: parseInt(calMatch[1]), sub: 0 };
    return { group: 4, year: 0, sub: 0 };
  };
  return [...contracts].sort((a, b) => {
    const oa = getOrder(a.contract_name);
    const ob = getOrder(b.contract_name);
    if (oa.group !== ob.group) return oa.group - ob.group;
    if (oa.year !== ob.year) return oa.year - ob.year;
    return oa.sub - ob.sub;
  });
};
